duracion_min: 30
faseProduccion: 0
id: 3
preguntas: 3
secciones:
- tipo: teoria
- tipo: quiz-practica
- tipo: recursos
titulo: Objetivos compartidos
